import { useEffect } from 'react'
import { setProxyInvalidHandler } from '../../api/proxyBridge'
import { useProxySwitch } from './useProxySwitch'

/**
 * Geçersiz vekalet kurtarma kancasını uygulama kabuğuna bağlar (089).
 *
 * <p>Sunucu `PROXY_NOT_ACTIVE` döndüğünde axios interceptor'ı `proxyBridge`'i tetikler; burada
 * bağlanan davranış kullanıcıyı kendi personasına düşürür, önbelleği geçersiz kılar ve anasayfaya
 * alır. Bilgilendirme mesajı interceptor'da gösterilir (tek toast noktası).
 *
 * <p>Kabukta (`AppLayout`) bir kez çağrılır: ekran bazlı bağlansaydı, kurtarma yalnız o ekranlarda
 * çalışır ve hangi sayfada olunduğuna göre davranış ayrışırdı.
 */
export function useProxyInvalidRecovery(): void {
  const { recoverFromInvalidPersona } = useProxySwitch()

  useEffect(() => {
    setProxyInvalidHandler(() => {
      recoverFromInvalidPersona()
    })
    return () => setProxyInvalidHandler(null)
  }, [recoverFromInvalidPersona])
}
